import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaTrash, FaPlusCircle, FaMinusCircle, FaMoneyBillWave, FaBan, FaClipboardList, FaDownload, FaFileExcel, FaFilePdf, FaWallet, FaChartBar } from "react-icons/fa";
import AdminNavbar from "../Layout/AdminNavbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import API_BASE_URL, { COMPANY_NAME } from "../config";

const SearchableSelect = ({ options, value, onChange, placeholder = "-- Select --", searchPlaceholder = "Search...", disabled = false }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const wrapRef = useRef(null);

    const selected = options.find(o => String(o.value) === String(value));
    const filtered = options.filter(o =>
        o.label.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        const handleOutside = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setOpen(false);
                setSearch("");
            }
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, []);

    return (
        <div ref={wrapRef} style={{ position: "relative" }}>
            <div
                className="form-select d-flex justify-content-between align-items-center"
                style={{
                    cursor: disabled ? "not-allowed" : "pointer",
                    backgroundColor: disabled ? "#e9ecef" : "#fff",
                    color: disabled ? "#6c757d" : "#212529",
                    userSelect: "none",
                }}
                onClick={() => { if (!disabled) setOpen(prev => !prev); }}
            >
                <span>{selected ? selected.label : <span className="text-muted">{placeholder}</span>}</span>
            </div>

            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "calc(100% + 2px)",
                        left: 0,
                        right: 0,
                        zIndex: 1055,
                        background: "#fff",
                        border: "1px solid #ced4da",
                        borderRadius: "6px",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                    }}
                >
                    <div style={{ padding: "8px 8px 4px" }}>
                        <input
                            autoFocus
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={searchPlaceholder}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            onClick={e => e.stopPropagation()}
                        />
                    </div>
                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                        {filtered.length > 0 ? filtered.map(o => (
                            <div
                                key={o.value}
                                style={{
                                    padding: "8px 14px",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    backgroundColor: String(o.value) === String(value) ? "#0d6efd" : "transparent",
                                    color: String(o.value) === String(value) ? "#fff" : "#212529",
                                }}
                                onMouseEnter={e => { if (String(o.value) !== String(value)) e.currentTarget.style.backgroundColor = "#f0f4ff"; }}
                                onMouseLeave={e => { if (String(o.value) !== String(value)) e.currentTarget.style.backgroundColor = "transparent"; }}
                                onClick={() => { onChange(String(o.value)); setOpen(false); setSearch(""); }}
                            >
                                {o.label}
                            </div>
                        )) : (
                            <div style={{ padding: "10px 14px", fontSize: "13px", color: "#6c757d" }}>No results found</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

const LeaveManagement = () => {
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [leaveLogs, setLeaveLogs] = useState([]);
    const [creditedDate, setCreditedDate] = useState("");
    const [financialYear, setFinancialYear] = useState("");
    const [encashDate, setEncashDate] = useState("");
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [rejectLeaveId, setRejectLeaveId] = useState(null);
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [searchTerm, setSearchTerm] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [showCreditModal, setShowCreditModal] = useState(false);
    const [modalLeaveType, setModalLeaveType] = useState("");
    const [modalLeavesPerMonth, setModalLeavesPerMonth] = useState("");
    const [availableLeaveTypes, setAvailableLeaveTypes] = useState([]);
    const [leaveSummary, setLeaveSummary] = useState([]);
    const [modalEmployeeId, setModalEmployeeId] = useState("");
    const [creditEmployees, setCreditEmployees] = useState([]);
    const [showAvailModal, setShowAvailModal] = useState(false);
    const [financialYearFrom, setFinancialYearFrom] = useState("");
    const [financialYearTo, setFinancialYearTo] = useState("");
    const [lopDays, setLopDays] = useState(0);
    const [navbarColor, setNavbarColor] = useState("#080235");
    const [loading, setLoading] = useState(true);


    const [availForm, setAvailForm] = useState({
        leaveType: "",
        startDate: "",
        endDate: "",
        reason: "",
        document: null,
    });

    const [showEncashModal, setShowEncashModal] = useState(false);

    const [encashForm, setEncashForm] = useState({
        leaveType: "",
        days: ""
    });

    const [sortConfig, setSortConfig] = useState({
        key: "",
        direction: "asc",
    });


    const sortedCreditEmployees = [...creditEmployees].sort((a, b) =>
        a.user.name.localeCompare(b.user.name)
    );


    // const fetchAppliedLeaves = () => {
    //     const token = localStorage.getItem("token");
    //     if (!token || !selectedEmployee) return;

    //     fetch(`${API_BASE_URL}/api/leaves/all`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             // filter by selected employee
    //             const emp = employees.find(e => e.id === Number(selectedEmployee));
    //             if (!emp) return;

    //             const filtered = data.filter(
    //                 l => l.employeeName === emp.user.name
    //             );

    //             setAppliedLeaves(filtered);
    //         })
    //         .catch(err => console.error("Error fetching applied leaves", err));
    // };



    const handleAvailSubmit = async () => {
        try {
            const token = localStorage.getItem("token");

            if (
                !modalEmployeeId ||
                !availForm.leaveType ||
                !availForm.startDate ||
                !availForm.endDate ||
                !availForm.reason
            ) {
                toast.error("Please fill all required fields");
                return;
            }

            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/avail`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        employeeId: Number(modalEmployeeId),
                        leaveType: availForm.leaveType,
                        startDate: availForm.startDate,
                        endDate: availForm.endDate,
                        reason: availForm.reason,
                        financialYear: financialYear,
                    }),
                }
            );

            if (!res.ok) {
                const errorText = await res.text();

                //  show friendly message only
                if (errorText.includes("Insufficient leave balance")) {
                    toast.error("Insufficient leave balance");
                } else {
                    toast.error("Failed to avail leave");
                }
                return;
            }

            toast.success("Leave availed successfully");

            setShowAvailModal(false);
            setAvailForm({
                leaveType: "",
                startDate: "",
                endDate: "",
                reason: "",
                document: null,
            });

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong. Please try again.");
        }
    };


    const getStartOfMonth = (value) => {
        if (!value) return "";

        const [month, year] = value.trim().split(" ");

        const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
        if (isNaN(monthIndex)) return "";

        return `01/${String(monthIndex + 1).padStart(2, "0")}/${year}`;
    };

    const getEndOfMonth = (value) => {
        if (!value) return "";

        const [month, year] = value.trim().split(" ");

        const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
        if (isNaN(monthIndex)) return "";

        //  last day of the month
        const lastDay = new Date(year, monthIndex + 1, 0).getDate();

        return `${lastDay}/${String(monthIndex + 1).padStart(2, "0")}/${year}`;
    };

    const parseDDMMYYYY = (dateStr) => {
        if (!dateStr) return null;
        const [dd, mm, yyyy] = dateStr.split("/");
        return new Date(`${yyyy}-${mm}-${dd}`);
    };

    useEffect(() => {
        const token = localStorage.getItem("token");
        const roles = JSON.parse(localStorage.getItem("roles") || "[]");

        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
            return;
        }

        //  check admin role
        if (!roles.includes("ROLE_ADMIN")) {
            toast.error("You are not authorized to access this page.");
            navigate("/");
            return;
        }
    }, [navigate]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        if (!token || !userId) return;
        const controller = new AbortController();
        fetch(`${API_BASE_URL}/api/appearance/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal,
        })
            .then(r => r.json())
            .then(d => { if (d?.navbarColor) setNavbarColor(d.navbarColor); })
            .catch(() => {});
        return () => controller.abort();
    }, []);

    // useEffect(() => {
    //     const token = localStorage.getItem("token");
    //     fetch(`${API_BASE_URL}/api/users`, {
    //         headers: { Authorization: "Bearer " + token },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             setEmployees(data.filter(u => u.status === "Active"));
    //         })
    //         .catch(err => console.error(err));
    // }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");

        const companyFetch = fetch(`${API_BASE_URL}/api/company-info`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => {
                const company = Array.isArray(data) ? data[0] : data;
                if (!company?.financialYear) return;
                setFinancialYear(company.financialYear);
                const parts = splitFinancialYear(company.financialYear);
                if (parts.length !== 2) return;
                const [from, to] = parts;
                setFinancialYearFrom(getStartOfMonth(from));
                setFinancialYearTo(getEndOfMonth(to));
            })
            .catch(err => console.error("Error fetching company info:", err));

        const employeesFetch = fetch(`${API_BASE_URL}/api/employees/active`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => {
                setEmployees(data);
                setCreditEmployees(data);
                const uniqueDepartments = [
                    ...new Set(data.map(emp => emp.department).filter(Boolean))
                ];
                setDepartments(uniqueDepartments);
                setFilteredEmployees(data);
            })
            .catch(err => console.error(err));

        Promise.all([companyFetch, employeesFetch]).finally(() => setLoading(false));
    }, []);

    const toInputDate = (ddmmyyyy) => {
        if (!ddmmyyyy) return "";
        const [dd, mm, yyyy] = ddmmyyyy.split("/");
        return `${yyyy}-${mm}-${dd}`;
    };

    const minCreditDate = toInputDate(financialYearFrom);
    const maxCreditDate = toInputDate(financialYearTo);

    const minAvailDate = toInputDate(financialYearFrom);
    const maxAvailDate = toInputDate(financialYearTo);

    const minEncashDate = toInputDate(financialYearFrom);
    const maxEncashDate = toInputDate(financialYearTo);


    useEffect(() => {
        if (!selectedDepartment) {
            // nothing selected → show no employees
            setFilteredEmployees([]);
            setSelectedEmployee("");
            return;
        }

        if (selectedDepartment === "ALL") {
            setFilteredEmployees(employees);
        } else {
            setFilteredEmployees(
                employees.filter(emp => emp.department === selectedDepartment)
            );
        }

        // reset employee when department changes
        setSelectedEmployee("");
    }, [selectedDepartment, employees]);


    //frontend filter by financial year
    // const fetchLogs = () => {
    //     const token = localStorage.getItem("token");

    //     if (!selectedEmployee || !financialYearFrom || !financialYearTo) {
    //         setLeaveLogs([]);
    //         return;
    //     }

    //     const fyStart = parseDDMMYYYY(financialYearFrom);
    //     const fyEnd = parseDDMMYYYY(financialYearTo);

    //     fetch(`${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             const filtered = data.filter(log => {
    //                 if (!log.startDate) return false;

    //                 const logDate = new Date(log.startDate);
    //                 return logDate >= fyStart && logDate <= fyEnd;
    //             });

    //             setLeaveLogs(filtered);
    //         })
    //         .catch(err =>
    //             console.error("Error fetching leave transactions", err)
    //         );
    // };



    //frontend filter by financial year
    // useEffect(() => {
    //     fetchLogs();
    // }, [selectedEmployee]);


    //from fanacial filter by directly backend

    const fetchLogs = () => {
        const token = localStorage.getItem("token");

        if (!selectedEmployee || !financialYear) {
            setLeaveLogs([]);
            return;
        }

        fetch(
            `${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}/financial-year?financialYear=${financialYear}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )
            .then(res => res.json())
            .then(data => setLeaveLogs(data))
            .catch(err =>
                console.error("Error fetching leave transactions", err)
            );
    };


    //from fanacial filter by directly backend

    useEffect(() => {
        fetchLogs();
    }, [selectedEmployee, financialYear]);


    //Not Filter All
    // const fetchLogs = () => {
    //     const token = localStorage.getItem("token");

    //     if (!selectedEmployee) {
    //         setLeaveLogs([]);
    //         return;
    //     }

    //     fetch(`${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //     })
    //         .then(res => res.json())
    //         .then(data => setLeaveLogs(data))
    //         .catch(err => console.error("Error fetching leave transactions", err));
    // };  

    const handleCredit = async () => {
        if (
            !modalEmployeeId ||
            !modalLeaveType ||
            !modalLeavesPerMonth ||
            !creditedDate

        ) {
            toast.error("Please select employee and fill all fields");
            return;
        }

        const token = localStorage.getItem("token");

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/credit`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        employeeId: Number(modalEmployeeId),
                        leaveType: modalLeaveType,
                        days: Number(modalLeavesPerMonth),
                        startDate: creditedDate,
                        financialYear: financialYear, //  from company-info
                    }),
                }
            );

            if (!res.ok) {
                const msg = await res.text();
                throw new Error(msg);
            }

            toast.success("Leave credited successfully");

            setShowCreditModal(false);
            setModalLeaveType("");
            setModalLeavesPerMonth("");
            setCreditedDate("");

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error(err.message || "Failed to credit leave");
        }
    };

    const handleEncashSubmit = async () => {
        const token = localStorage.getItem("token");

        if (
            !modalEmployeeId ||
            !encashForm.leaveType ||
            !encashForm.days ||
            !encashDate
        ) {
            toast.error("Please fill all required fields");
            return;
        }

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/encash`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        employeeId: Number(modalEmployeeId),
                        leaveType: encashForm.leaveType,
                        days: Number(encashForm.days),
                        startDate: encashDate,
                        financialYear: financialYear,
                    }),
                }
            );

            if (!res.ok) {
                const errorText = await res.text();

                //  show clean message only
                if (errorText.includes("Insufficient leave balance")) {
                    toast.error("Insufficient leave balance");
                } else {
                    toast.error("Failed to encash leave");
                }
                return;
            }

            toast.success("Leave encashed successfully");

            setShowEncashModal(false);
            setEncashForm({ leaveType: "", days: "" });
            setEncashDate("");

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error("Something went wrong. Please try again.");
        }
    };

    const confirmDelete = (log, onConfirm) => {
        toast(
            ({ closeToast }) => (
                <div style={{ minWidth: "280px" }}>
                    <p className="fw-semibold mb-2 text-danger">
                        Confirm Delete
                    </p>

                    <div className="mb-2 small">
                        <div><strong>Employee:</strong> {log.employeeName}</div>
                        <div><strong>Leave Type:</strong> {log.leaveType}</div>
                        <div>
                            <strong>Date:</strong>{" "}
                            {log.startDate
                                ? new Date(log.startDate).toLocaleDateString()
                                : "-"}
                        </div>
                        <div><strong>Days:</strong> {log.days}</div>
                    </div>

                    <p className="mb-2 text-muted small">
                        Are you sure you want to delete this leave transaction?
                    </p>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={closeToast}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                closeToast();
                                onConfirm();
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            ),
            {
                autoClose: false,
                closeOnClick: false,
            }
        );
    };


    const handleDelete = (log) => {
        confirmDelete(log, async () => {
            const token = localStorage.getItem("token");

            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/leave-transactions/${log.id}`,
                    {
                        method: "DELETE",
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                if (!res.ok) {
                    toast.error("Failed to delete record");
                    return;
                }

                toast.success("Leave record deleted");

                fetchLogs();
                fetchLeaveSummary(selectedEmployee);

            } catch (err) {
                console.error(err);
                toast.error("Error deleting record");
            }
        });
    };


    useEffect(() => {
        const token = localStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/leave-types/all`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => setAvailableLeaveTypes(data))
            .catch(err => console.error("Failed to fetch leave types:", err));
    }, []);


    useEffect(() => {
        fetchLeaveSummary(selectedEmployee);
    }, [selectedEmployee]);


    const filteredLogs = leaveLogs.filter(log => {
        const matchesSearch =
            log.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.leaveCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.leaveStatus?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.reason?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.processedBy?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.appliedBy?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus =
            statusFilter === "ALL" || log.leaveStatus === statusFilter;

        return matchesSearch && matchesStatus;
    });


    const fetchLeaveSummary = (userId) => {
        if (!userId || userId === "ALL") {
            setLeaveSummary([]);
            return;
        }

        const token = localStorage.getItem("token");

        fetch(
            `${API_BASE_URL}/api/leave-transactions/summary/${userId}?financialYear=${financialYear}`,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )
            .then(res => res.json())
            .then(data => {
                const filtered = data.filter(item => Number(item.remaining) > 0);
                setLeaveSummary(filtered);
            })

            .catch((err) => console.error("Error fetching leave summary:", err));
    };


    const sortedLogs = [...filteredLogs].sort((a, b) => {
        if (!sortConfig.key) return 0;

        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        //  Handle null / undefined safely
        if (aVal == null) aVal = "";
        if (bVal == null) bVal = "";

        // date handling
        if (sortConfig.key === "startDate" || sortConfig.key === "endDate") {
            aVal = aVal ? new Date(aVal) : new Date(0);
            bVal = bVal ? new Date(bVal) : new Date(0);
        }

        // string handling
        if (typeof aVal === "string") {
            aVal = aVal.toLowerCase();
            bVal = bVal.toLowerCase();
        }

        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });


    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    const paginatedLogs = sortedLogs.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(filteredLogs.length / entriesPerPage);

    const handleSort = (key) => {
        setSortConfig(prev => {
            if (prev.key === key) {
                // toggle direction
                return {
                    key,
                    direction: prev.direction === "asc" ? "desc" : "asc",
                };
            }
            // new column sort
            return { key, direction: "asc" };
        });
    };


    const splitFinancialYear = (fy) => {
        return fy.split(/\s*[–-]\s*/); // works for –, —
    };


    // filter applied leaves by search
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);


    // const calculateDays = (start, end) => {
    //     if (!start || !end) return 0;
    //     const s = new Date(start);
    //     const e = new Date(end);
    //     return e >= s ? Math.floor((e - s) / (1000 * 60 * 60 * 24)) + 1 : 0;
    // };


    useEffect(() => {
        if (!availForm.leaveType) return;
        if (availForm.leaveType === "Loss of Pay(LOP)") return;

        if (!availForm.startDate || !availForm.endDate) return;

        const start = new Date(availForm.startDate);
        const end = new Date(availForm.endDate);
        const requestedDays =
            end >= start
                ? Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1
                : 0;

        if (requestedDays === 0) return;

        const selectedLeave = leaveSummary.find(
            l => l.leaveType === availForm.leaveType
        );

        //  Not credited OR insufficient balance
        if (!selectedLeave || selectedLeave.remaining < requestedDays) {
            setAvailForm(prev => ({
                ...prev,
                leaveType: "Loss of Pay(LOP)"
            }));
        }

    }, [
        availForm.leaveType,
        availForm.startDate,
        availForm.endDate,
        leaveSummary
    ]);

    const handleApprove = async (logId) => {
        const token = localStorage.getItem("token");

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/approve/${logId}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!res.ok) {
                const msg = await res.text();
                throw new Error(msg);
            }

            toast.success("Leave approved");
            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error(err.message || "Failed to approve leave");
        }
    };

    const handleReject = async () => {
        if (!rejectReason.trim()) {
            toast.error("Please enter rejection reason");
            return;
        }

        const token = localStorage.getItem("token");

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/reject/${rejectLeaveId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        actionReason: rejectReason
                    }),
                }
            );

            if (!res.ok) {
                const msg = await res.text();
                throw new Error(msg);
            }

            toast.success("Leave rejected");
            setShowRejectModal(false);

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error(err.message || "Failed to reject leave");
        }
    };


    const getStatusBadgeClass = (status) => {
        switch (status) {
            case "APPROVED":
                return "bg-success";
            case "REJECTED":
                return "bg-danger";
            case "PENDING":
                return "bg-warning text-dark";
            case "FORWARDED":
                return "bg-primary";
            case "CREDITED":
                return "bg-info text-dark";
            case "ENCASHED":
                return "bg-secondary";
            default:
                return "bg-light text-dark";
        }
    };


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token || !selectedEmployee || !financialYear) {
            setLopDays(0);
            return;
        }

        fetch(
            `${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}/lop-days?financialYear=${financialYear}`,
            {
                headers: { Authorization: "Bearer " + token },
            }
        )
            .then(res => {
                if (!res.ok) throw new Error("Failed to fetch LOP days");
                return res.json();
            })
            .then(data => {
                setLopDays(data || 0);
            })
            .catch(err => {
                console.error("Error fetching LOP days:", err);
                setLopDays(0);
            });
    }, [selectedEmployee, financialYear]);


    const truncate = (text, max = 30) =>
        text && text.length > max ? text.substring(0, max) + "..." : text;


    const handleExport = async (format) => {

        const token = localStorage.getItem("token");

        // ✅ Ask confirmation if exporting all employees
        if (!selectedEmployee) {

            const confirmExport = window.confirm(
                "Export leave report for ALL employees?"
            );

            if (!confirmExport) return;
        }

        try {

            let url =
                `${API_BASE_URL}/api/reports/leave-transactions` +
                `?format=${format}` +
                `&financialYear=${financialYear}`;

            if (selectedEmployee) {
                url += `&employeeId=${selectedEmployee}`;
            }

            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (!response.ok) throw new Error("Export failed");

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = downloadUrl;

            let fileName = "Leave_Report_All_Employees";

            if (selectedEmployee) {
                const emp = employees.find(
                    e => String(e.id) === String(selectedEmployee)
                );

                const empName =
                    emp?.user?.name?.replace(/\s+/g, "_") || "Employee";

                fileName = `Leave_Report_${empName}`;
            }

            link.download =
                `${fileName}_${financialYear}.${format === "pdf" ? "pdf" : "xlsx"}`;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

            toast.success("Report downloaded");

        } catch (error) {
            console.error(error);
            toast.error("Export failed");
        }
    };


    if (loading) {
        return (
            <>
                <div className="fixed-top"><AdminNavbar /></div>
                <div style={{ paddingTop: "120px", minHeight: "100vh", backgroundColor: "#f0f2f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" style={{ width: "3rem", height: "3rem" }} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="text-muted fw-semibold" style={{ fontSize: "14px" }}>Loading leave data...</div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <style>{`
                .lm-scroll::-webkit-scrollbar { width: 6px; }
                .lm-scroll::-webkit-scrollbar-track { background: transparent; }
                .lm-scroll::-webkit-scrollbar-thumb { background: #ced4da; border-radius: 99px; }
                .lm-scroll::-webkit-scrollbar-thumb:hover { background: #adb5bd; }
                .lm-table-wrap::-webkit-scrollbar { height: 5px; }
                .lm-table-wrap::-webkit-scrollbar-track { background: transparent; }
                .lm-table-wrap::-webkit-scrollbar-thumb { background: #ced4da; border-radius: 99px; }
                .lm-table-wrap::-webkit-scrollbar-thumb:hover { background: #adb5bd; }
            `}</style>
            <div className="fixed-top">
                <AdminNavbar />
            </div>

            <div style={{ paddingTop: "106px", height: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#f0f2f5", overflow: "hidden" }}>
                <div className="lm-scroll container-fluid" style={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}>
                {/* PAGE HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h4 className="fw-bold mb-0 text-dark d-flex align-items-center gap-2"><FaClipboardList /> Leave Management</h4>
                        <small className="text-muted">Manage employee leave credits, avails and encashments</small>
                    </div>
                    <div className="dropdown">
                        <button
                            className="btn btn-success btn-sm dropdown-toggle px-3"
                            type="button"
                            data-bs-toggle="dropdown"
                        >
                            <FaDownload className="me-1" /> Export Report
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end shadow-sm">
                            <li>
                                <button className="dropdown-item" onClick={() => handleExport("excel")}>
                                    <FaFileExcel className="me-2 text-success" /> Export Excel
                                </button>
                            </li>
                            <li>
                                <button className="dropdown-item" onClick={() => handleExport("pdf")}>
                                    <FaFilePdf className="me-2 text-danger" /> Export PDF
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* FILTER CARD */}
                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: "12px" }}>
                    <div className="card-header bg-white border-0 pt-3 pb-0 px-4">
                        <span className="fw-semibold text-secondary small">🔍 Filter &amp; Actions</span>
                    </div>
                    <div className="card-body px-4 pb-3 pt-2">
                        <div className="row g-3 align-items-end">
                            <div className="col-md-2">
                                <label className="form-label fw-semibold small text-secondary mb-1">Department</label>
                                <SearchableSelect
                                    options={[
                                        { value: "ALL", label: "ALL Departments" },
                                        ...departments.map(dep => ({ value: dep, label: dep }))
                                    ]}
                                    value={selectedDepartment}
                                    onChange={setSelectedDepartment}
                                    placeholder="Select Department"
                                    searchPlaceholder="Search department..."
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label fw-semibold small text-secondary mb-1">Employee</label>
                                <SearchableSelect
                                    options={filteredEmployees.map(emp => ({ value: String(emp.id), label: emp.user.name }))}
                                    value={selectedEmployee}
                                    onChange={setSelectedEmployee}
                                    placeholder={selectedDepartment ? "Select Employee" : "Select Dept First"}
                                    searchPlaceholder="Search employee..."
                                    disabled={!selectedDepartment}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label fw-semibold small text-secondary mb-1">FY From</label>
                                <input className="form-control form-control-sm bg-light text-muted" value={financialYearFrom} disabled />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label fw-semibold small text-secondary mb-1">FY To</label>
                                <input className="form-control form-control-sm bg-light text-muted" value={financialYearTo} disabled />
                            </div>

                            <div className="col-md-4 d-flex gap-2 justify-content-end flex-wrap">
                                <button
                                    className="btn btn-primary btn-sm px-3"
                                    onClick={() => {
                                        setModalEmployeeId(selectedEmployee || "");
                                        setCreditedDate(new Date().toISOString().split("T")[0]);
                                        setShowCreditModal(true);
                                    }}
                                >
                                    ➕ Credit
                                </button>
                                <button
                                    className="btn btn-info text-white btn-sm px-3"
                                    onClick={() => {
                                        const today = new Date().toISOString().split("T")[0];
                                        setModalEmployeeId(selectedEmployee || "");
                                        setAvailForm(prev => ({ ...prev, startDate: today, endDate: today }));
                                        setShowAvailModal(true);
                                    }}
                                >
                                    ➖ Avail
                                </button>
                                <button
                                    className="btn btn-success btn-sm px-3"
                                    onClick={() => {
                                        setModalEmployeeId(selectedEmployee || "");
                                        setEncashForm({ leaveType: "", days: "" });
                                        setEncashDate(new Date().toISOString().split("T")[0]);
                                        setShowEncashModal(true);
                                    }}
                                >
                                    💰 Encash
                                </button>
                                <button
                                    className="btn btn-danger btn-sm px-3"
                                    onClick={() => navigate(-1)}
                                >
                                    ⏻ Exit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* TABLE CONTROLS */}
                <div className="d-flex align-items-center justify-content-between mb-3 px-1 flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                        <div className="d-flex align-items-center gap-2">
                            <span className="text-secondary fw-semibold small">Status:</span>
                            <select
                                className="form-select form-select-sm"
                                style={{ width: "145px" }}
                                value={statusFilter}
                                onChange={e => { setStatusFilter(e.target.value); setCurrentPage(1); }}
                            >
                                <option value="ALL">All Status</option>
                                <option value="PENDING">Pending</option>
                                <option value="FORWARDED">Forwarded</option>
                                <option value="APPROVED">Approved</option>
                                <option value="REJECTED">Rejected</option>
                                <option value="CREDITED">Credited</option>
                                <option value="ENCASHED">Encashed</option>
                            </select>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <span className="text-secondary fw-semibold small">Show:</span>
                            <select
                                className="form-select form-select-sm w-auto"
                                value={entriesPerPage}
                                onChange={e => { setEntriesPerPage(Number(e.target.value)); setCurrentPage(1); }}
                            >
                                <option value={5}>5</option>
                                <option value={7}>7</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                            </select>
                            <span className="text-secondary small">entries</span>
                        </div>
                    </div>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ width: "250px" }}
                        placeholder="🔍  Search leave type, status, reason..."
                        value={searchTerm}
                        onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    />
                </div>

                {/* MAIN CONTENT */}
                <div className="row g-3">
                    {/* LEFT TABLE */}
                    <div className="col-md-9">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: "12px", overflow: "hidden" }}>
                            <div className="table-responsive lm-table-wrap">
                                <table className="table table-hover table-bordered mb-0" style={{ fontSize: "13px" }}>
                                    <thead style={{ backgroundColor: navbarColor, color: "white" }}>
                                        <tr>
                                            <th onClick={() => handleSort("leaveCode")} style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                                                Leave Code {sortConfig.key === "leaveCode" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                            <th onClick={() => handleSort("leaveType")} style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                                                Leave Type {sortConfig.key === "leaveType" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                            <th onClick={() => handleSort("startDate")} style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                                                Start Date {sortConfig.key === "startDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                            <th onClick={() => handleSort("endDate")} style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                                                End Date {sortConfig.key === "endDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                            <th onClick={() => handleSort("days")} style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                                                Days {sortConfig.key === "days" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                            <th onClick={() => handleSort("leaveStatus")} style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                                                Status {sortConfig.key === "leaveStatus" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                            <th style={{ whiteSpace: "nowrap" }}>Leave Reason</th>
                                            <th onClick={() => handleSort("appliedBy")} style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                                                Applied By {sortConfig.key === "appliedBy" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                            <th style={{ whiteSpace: "nowrap" }}>Action Reason</th>
                                            <th style={{ whiteSpace: "nowrap" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedLogs.length > 0 ? (
                                            paginatedLogs.map(log => (
                                                <tr key={log.id} style={{ verticalAlign: "middle" }}>
                                                    <td className="fw-semibold text-primary">{log.leaveCode}</td>
                                                    <td>{log.leaveType}</td>
                                                    <td className="text-nowrap">{log.startDate || "—"}</td>
                                                    <td className="text-nowrap">{log.endDate || "—"}</td>
                                                    <td className="text-center fw-bold">{log.days}</td>
                                                    <td>
                                                        <span className={`badge rounded-pill ${getStatusBadgeClass(log.leaveStatus)}`} style={{ fontSize: "11px", padding: "4px 10px" }}>
                                                            {log.leaveStatus}
                                                        </span>
                                                    </td>
                                                    <td title={log.reason || ""} style={{ maxWidth: "140px" }}>
                                                        <span className="text-muted">{truncate(log.reason, 25) || "—"}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: "nowrap" }}>{log.processedBy || log.appliedBy || "—"}</td>
                                                    <td title={log.actionReason || ""} style={{ maxWidth: "120px" }}>
                                                        <span className="text-muted">{truncate(log.actionReason, 20) || "—"}</span>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex gap-1 flex-wrap align-items-center">
                                                            {(log.leaveStatus === "PENDING" || log.leaveStatus === "FORWARDED") && (
                                                                <>
                                                                    <button
                                                                        className="btn btn-sm btn-success py-0 px-2"
                                                                        style={{ fontSize: "11px" }}
                                                                        onClick={() => handleApprove(log.id)}
                                                                    >
                                                                        ✔ Approve
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm btn-warning text-dark py-0 px-2"
                                                                        style={{ fontSize: "11px" }}
                                                                        onClick={() => {
                                                                            setRejectLeaveId(log.id);
                                                                            setRejectReason("");
                                                                            setShowRejectModal(true);
                                                                        }}
                                                                    >
                                                                        ✖ Reject
                                                                    </button>
                                                                </>
                                                            )}
                                                            <button
                                                                className="btn btn-sm btn-danger py-1 px-2"
                                                                style={{ lineHeight: 1 }}
                                                                onClick={() => handleDelete(log)}
                                                                title="Delete"
                                                            >
                                                                <FaTrash size={13} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" className="text-center py-5">
                                                    <div className="text-muted">
                                                        <div style={{ fontSize: "40px" }}>📂</div>
                                                        <div className="fw-semibold mt-2">No leave records found</div>
                                                        <small>Select a department and employee to view leave transactions</small>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* TABLE FOOTER: count + pagination */}
                            <div
                                className="card-footer bg-white border-top d-flex justify-content-between align-items-center py-2 px-3"
                                style={{ fontSize: "12px" }}
                            >
                                <span className="text-muted">
                                    {filteredLogs.length > 0
                                        ? `Showing ${indexOfFirst + 1}–${Math.min(indexOfLast, filteredLogs.length)} of ${filteredLogs.length} records`
                                        : "No records"}
                                </span>
                                {totalPages > 1 && (
                                    <nav>
                                        <ul className="pagination pagination-sm mb-0">
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>‹ Prev</button>
                                            </li>
                                            {Array.from({ length: totalPages }, (_, i) => (
                                                <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                                </li>
                                            ))}
                                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next ›</button>
                                            </li>
                                        </ul>
                                    </nav>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT BALANCE PANEL */}
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: "12px", overflow: "hidden" }}>
                            <div
                                className="card-header border-0 py-2 px-3"
                                style={{ backgroundColor: navbarColor }}
                            >
                                <h6 className="text-white mb-0 fw-semibold d-flex align-items-center gap-2"><FaWallet /> Leave Balance</h6>
                            </div>
                            <div className="card-body p-0">
                                {leaveSummary.length > 0 ? (
                                    <ul className="list-group list-group-flush">
                                        {leaveSummary.map((item, index) => (
                                            <li
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center px-3 py-2"
                                                style={{ fontSize: "13px" }}
                                            >
                                                <span className="text-secondary">{item.leaveType}</span>
                                                <span className="badge bg-primary rounded-pill">{item.remaining}</span>
                                            </li>
                                        ))}
                                        <li className="list-group-item d-flex justify-content-between align-items-center px-3 py-2" style={{ fontSize: "13px" }}>
                                            <span className="text-danger fw-semibold">Loss of Pay (LOP)</span>
                                            <span className="badge bg-danger rounded-pill">{lopDays}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center px-3 py-2 bg-light" style={{ fontSize: "13px" }}>
                                            <span className="fw-bold text-dark">Total Balance</span>
                                            <span className="badge bg-success rounded-pill fw-bold">
                                                {leaveSummary.reduce((sum, item) => sum + Number(item.remaining), 0)}
                                            </span>
                                        </li>
                                    </ul>
                                ) : (
                                    <>
                                        <div className="text-center text-muted py-4 px-3" style={{ fontSize: "13px" }}>
                                            <FaChartBar size={32} className="text-muted" />
                                            <div className="mt-1 small">No leave balance available</div>
                                        </div>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item d-flex justify-content-between align-items-center px-3 py-2" style={{ fontSize: "13px" }}>
                                                <span className="text-danger fw-semibold">Loss of Pay (LOP)</span>
                                                <span className="badge bg-danger rounded-pill">{lopDays}</span>
                                            </li>
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* FOOTER */}
                <hr className="my-4" />
                <div className="text-center text-muted small mb-3">
                    © {new Date().getFullYear()} — {COMPANY_NAME} · Balsuite System
                </div>

                {/* CREDIT MODAL */}
                {showCreditModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>
                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "540px" }}>
                                <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "16px", overflow: "visible" }}>
                                    <div
                                        className="modal-header border-0 py-3 px-4"
                                        style={{ backgroundColor: navbarColor, borderRadius: "16px 16px 0 0" }}
                                    >
                                        <h5 className="modal-title text-white fw-bold mb-0 d-flex align-items-center gap-2"><FaPlusCircle /> Credit Leave</h5>
                                        <button type="button" className="btn-close btn-close-white" onClick={() => setShowCreditModal(false)}></button>
                                    </div>
                                    <div className="modal-body px-4 py-3">
                                        <div className="row g-3">
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Employee <span className="text-danger">*</span></label>
                                                <SearchableSelect
                                                    options={sortedCreditEmployees.map(emp => ({ value: emp.id, label: emp.user.name }))}
                                                    value={modalEmployeeId}
                                                    onChange={setModalEmployeeId}
                                                    placeholder="Select Employee"
                                                    disabled={!!selectedEmployee}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Leave Type <span className="text-danger">*</span></label>
                                                <SearchableSelect
                                                    options={availableLeaveTypes.map(type => ({ value: type.name, label: type.name }))}
                                                    value={modalLeaveType}
                                                    onChange={setModalLeaveType}
                                                    placeholder="Select Leave Type"
                                                    searchPlaceholder="Search leave type..."
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Days <span className="text-danger">*</span></label>
                                                <input
                                                    type="number"
                                                    step="0.5"
                                                    className="form-control"
                                                    placeholder="e.g. 1.5"
                                                    value={modalLeavesPerMonth}
                                                    onChange={e => setModalLeavesPerMonth(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Credited Date <span className="text-danger">*</span></label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={creditedDate}
                                                    min={minCreditDate}
                                                    max={maxCreditDate}
                                                    onChange={e => setCreditedDate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer border-0 px-4 pb-4 pt-1 gap-2" style={{ borderRadius: "0 0 16px 16px" }}>
                                        <button className="btn btn-primary px-4" onClick={handleCredit}>Save</button>
                                        <button className="btn btn-sm btn-secondary px-4" onClick={() => setShowCreditModal(false)}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* AVAIL MODAL */}
                {showAvailModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>
                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "540px" }}>
                                <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "16px", overflow: "visible" }}>
                                    <div
                                        className="modal-header border-0 py-3 px-4"
                                        style={{ backgroundColor: navbarColor, borderRadius: "16px 16px 0 0" }}
                                    >
                                        <h5 className="modal-title text-white fw-bold mb-0 d-flex align-items-center gap-2"><FaMinusCircle /> Avail Leave</h5>
                                        <button type="button" className="btn-close btn-close-white" onClick={() => setShowAvailModal(false)} />
                                    </div>
                                    <div className="modal-body px-4 py-3">
                                        <div className="row g-3">
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Employee <span className="text-danger">*</span></label>
                                                <SearchableSelect
                                                    options={sortedCreditEmployees.map(emp => ({ value: emp.id, label: emp.user.name }))}
                                                    value={modalEmployeeId}
                                                    onChange={setModalEmployeeId}
                                                    placeholder="Select Employee"
                                                    disabled={!!selectedEmployee}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Leave Type <span className="text-danger">*</span></label>
                                                <SearchableSelect
                                                    options={availableLeaveTypes.map(type => ({ value: type.name, label: type.name }))}
                                                    value={availForm.leaveType}
                                                    onChange={val => setAvailForm({ ...availForm, leaveType: val })}
                                                    placeholder="Select Leave Type"
                                                    searchPlaceholder="Search leave type..."
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Start Date <span className="text-danger">*</span></label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={availForm.startDate}
                                                    min={minAvailDate}
                                                    max={maxAvailDate}
                                                    onChange={e => setAvailForm({ ...availForm, startDate: e.target.value, endDate: "" })}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">End Date <span className="text-danger">*</span></label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={availForm.endDate}
                                                    min={availForm.startDate || minAvailDate}
                                                    max={maxAvailDate}
                                                    onChange={e => setAvailForm({ ...availForm, endDate: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold small">Reason <span className="text-danger">*</span></label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    placeholder="Enter reason for leave..."
                                                    value={availForm.reason}
                                                    onChange={e => setAvailForm({ ...availForm, reason: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer border-0 px-4 pb-4 pt-1 gap-2" style={{ borderRadius: "0 0 16px 16px" }}>
                                        <button className="btn btn-info text-white px-4" onClick={handleAvailSubmit}>Save</button>
                                        <button className="btn btn-secondary px-4" onClick={() => setShowAvailModal(false)}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* ENCASH MODAL */}
                {showEncashModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>
                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "540px" }}>
                                <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "16px", overflow: "visible" }}>
                                    <div
                                        className="modal-header border-0 py-3 px-4"
                                        style={{ backgroundColor: navbarColor, borderRadius: "16px 16px 0 0" }}
                                    >
                                        <h5 className="modal-title text-white fw-bold mb-0 d-flex align-items-center gap-2"><FaMoneyBillWave /> Encash Leave</h5>
                                        <button type="button" className="btn-close btn-close-white" onClick={() => setShowEncashModal(false)} />
                                    </div>
                                    <div className="modal-body px-4 py-3">
                                        <div className="row g-3">
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Employee <span className="text-danger">*</span></label>
                                                <SearchableSelect
                                                    options={sortedCreditEmployees.map(emp => ({ value: emp.id, label: emp.user.name }))}
                                                    value={modalEmployeeId}
                                                    onChange={setModalEmployeeId}
                                                    placeholder="Select Employee"
                                                    disabled={!!selectedEmployee}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Leave Type <span className="text-danger">*</span></label>
                                                <SearchableSelect
                                                    options={availableLeaveTypes.map(type => ({ value: type.name, label: type.name }))}
                                                    value={encashForm.leaveType}
                                                    onChange={val => setEncashForm({ ...encashForm, leaveType: val })}
                                                    placeholder="Select Leave Type"
                                                    searchPlaceholder="Search leave type..."
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Encash Days <span className="text-danger">*</span></label>
                                                <input
                                                    type="number"
                                                    min="0.5"
                                                    step="0.5"
                                                    className="form-control"
                                                    placeholder="e.g. 2"
                                                    value={encashForm.days}
                                                    onChange={e => setEncashForm({ ...encashForm, days: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-semibold small">Encash Date <span className="text-danger">*</span></label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={encashDate}
                                                    min={minEncashDate}
                                                    max={maxEncashDate}
                                                    onChange={e => setEncashDate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer border-0 px-4 pb-4 pt-1 gap-2" style={{ borderRadius: "0 0 16px 16px" }}>
                                        <button className="btn btn-success px-4" onClick={handleEncashSubmit}>Save</button>
                                        <button className="btn btn-secondary px-4" onClick={() => setShowEncashModal(false)}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* REJECT MODAL */}
                {showRejectModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>
                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "420px" }}>
                                <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "16px", overflow: "hidden" }}>
                                    <div
                                        className="modal-header border-0 py-3 px-4"
                                        style={{ backgroundColor: navbarColor }}
                                    >
                                        <h5 className="modal-title text-white fw-bold mb-0 d-flex align-items-center gap-2"><FaBan /> Reject Leave</h5>
                                        <button type="button" className="btn-close btn-close-white" onClick={() => setShowRejectModal(false)} />
                                    </div>
                                    <div className="modal-body px-4 py-3">
                                        <label className="form-label fw-semibold small">Rejection Reason <span className="text-danger">*</span></label>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            value={rejectReason}
                                            onChange={e => setRejectReason(e.target.value)}
                                            placeholder="Please enter the reason for rejection..."
                                        />
                                    </div>
                                    <div className="modal-footer border-0 px-4 pb-4 pt-1 gap-2">
                                        <button className="btn btn-secondary px-4" onClick={() => setShowRejectModal(false)}>Cancel</button>
                                        <button className="btn btn-warning px-4" onClick={handleReject}>Reject</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                </div>
            </div>
        </>
    );
};

export default LeaveManagement;
